import './InlineMetadata.scss';
import { DetailSubsection } from '../DetailSubsection';
import React from 'react';
export const InlineMetadata = ({ children, headerSpaceAlign, label }) => React.createElement(DetailSubsection, { className: 'inline-metadata', headerSpaceAlign: headerSpaceAlign, title: label, titleExtra: children });
